/* unplugin-vue-components disabled */import { createVNode as _createVNode2, createTextVNode as _createTextVNode2 } from "vue";
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import { warning } from "../components/notice";
import useRequest from "../use/useRequest";
import { Confirm } from "linkd-ui";
export default /*#__PURE__*/_defineComponent({
  __name: 'YExport',
  props: {
    para: {
      type: Object,
      default: () => ({})
    },
    simple: Boolean,
    //   activityRegistration: {
    //     type: Boolean,
    //     default: () => false,
    //   },
    api: String,
    hasPager: Boolean,
    show: Boolean,
    preProcess: () => {} //请求前对参数进行预处理
  },

  emits: ["update:show"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const $controller = inject("$controller");
    const router = useRouter();
    // 定义Props
    // 导出
    const {
      isLoading,
      getData
    } = useRequest({
      api: props.api,
      para: props.para,
      manual: true,
      afterProcess(data) {
        afterExport(data);
      }
    });
    function onExport() {
      let para = JSON.parse(JSON.stringify(props.para));
      if (props.hasPager) {
        para.pageCurrent = 1;
        para.pageSize = 20;
      }
      //   if (props.activityRegistration) {
      //     para.cityCode = para.cityCode.join(",");
      //   }
      if (!para || !props.api) {
        return warning("请传入导出所需参数！");
      }
      //   const loadingInstance: any = ElLoading.service({ body: true })
      getData(props.api, para).finally(() => {
        // loadingInstance.close()
      });
    }
    // 导出
    function afterExport(data) {
      Confirm.open({
        title: "提示",
        content: () => {
          return _createVNode2("ul", null, [_createVNode2("li", {
            "class": "lh30"
          }, [_createTextVNode2("\u8BF7\u524D\u5F80\u3010 \u4E0B\u8F7D\u5217\u8868 \u3011\u4E0B\u8F7D\u8BE5\u6587\u4EF6")])]);
        },
        okText: "去下载列表",
        ok() {
          onGotoDown();
        }
      });
    }
    // 到下载列表
    function onGotoDown() {
      emit("update:show", false);
      $controller.open("下载列表", "/base-center/system-configuration/download/list");
    }
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_y_button = _resolveComponent("y-button");
      return __props.simple ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        onClick: onExport
      }, [_renderSlot(_ctx.$slots, "default")])) : (_openBlock(), _createBlock(_component_y_button, {
        key: 1,
        action: "",
        type: "default",
        onClick: onExport,
        mode: "line"
      }, {
        default: _withCtx(() => [_createVNode(_component_Icon, {
          fontClassName: "iconfont",
          name: "icon-a-daochu1",
          color: "#666",
          style: {
            "font-size": "12px"
          }
        }), _createTextVNode("   "), _renderSlot(_ctx.$slots, "default", {}, () => [_createTextVNode("导出")])]),
        _: 3
      }));
    };
  }
});